'use strict';

import type { UserAlert } from '../../Entities/User/UserAlert';
import { EntityCollection } from '../EntityCollection';

export class UserAlertCollection extends EntityCollection<UserAlert> {}
